import { Box, Button, IconButton } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";
import * as XLSX from "xlsx";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import EditOrderModal from "../../../EditOrderModal";
import { handleEditOrderModal } from "../../../../reducers/uiSlice";
import { useDispatch, useSelector } from "react-redux";
import { getUserById, getBranchById, getScanSatus } from "../../../../utilities/common";

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    group: {
        display: 'flex',
        alignItems: 'center'
    },
    item: {
        color: 'white'
    },
    formControl: {
        marginBottom: theme.spacing(1),
        minWidth: 220,

    },
    leftSection: {
        paddingTop: theme.spacing(3),
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'left',
    },
    dialog: {
        overflow: 'auto',
        maxHeight: '60vh',
        '&::-webkit-scrollbar': {
            width: '7px',
            backgroundColor: 'lightgray',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'gray',
            borderRadius: '4px',
            height: '60px'
        },
    }
}));

function CompensatedTable(props) {
    const { t } = useTranslation('incidentManagement');
    const PAGE_SIZE = 20;
    const classes = useStyles();
    const dispatch = useDispatch();
    const branchList = useSelector(state => state.common.branches);
    const userList = useSelector(state => state.common.users);
    const statusList = useSelector(state => state.incidentManagement.statusList);

    const getNameById = (params, list) => {
        //getValue from data-grid is bugged in this current version
        return _.find(list, { 'id': params.value })?.name || ""
    }

    const Column = [
        {
            field: 'tracking_number',
            headerName: t('tracking_number'),
            width: 200,
            renderCell: (params) => (
                <Button
                    onClick={() => _handleEditOrderModal(true, params.value)}
                    style={{
                        cursor: 'pointer',
                        color: 'orange',
                        textDecoration: 'underline',
                    }}
                >
                    {params.value}
                </Button>
            ),
        },
        { field: 'shipping_staff_id', headerName: t('serch_by_driver'), width: 140, valueGetter: (params) => params.value ? params.value : '' },
        { field: 'warehouse', headerName: t('warehouse'), width: 210, valueFormatter: (params) => getBranchById(params.value, branchList)?.name.replace("Warehouse", "").trim() || params.value },
        { field: 'driver_dispatches_record', headerName: t('scan_status'), width: 160, valueGetter: (params) => t('editOrder:' + getScanSatus(params.value)) },

        {
            field: 'last_tracking_path',
            headerName: t('last_tracking_path'),
            width: 200,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'last_path_update',
            headerName: t('last_path_update'),
            width: 180,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'incident_id',
            headerName: t('incident_id'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            // renderCell: (params) => (
            //     <Button
            //         onClick={() => props.openIncidentForm({ open: true, id: params.value })}
            //         style={{
            //             cursor: 'pointer',
            //             color: 'orange',
            //             textDecoration: 'underline',
            //             minWidth: 100,
            //         }}
            //         fullWidth
            //     >
            //         {params.value}
            //     </Button>
            // ),
        },
        { field: 'incident_type', headerName: t('incident_type'), width: 300, valueGetter: (params) => getNameById(params, statusList.incidentTypeList) },
        { field: 'status', headerName: t('investigation_status_short'), width: 120, valueGetter: (params) => getNameById(params, statusList.incidentStatusList) },
        {
            field: 'notes',
            headerName: t('notes'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'pod',
            headerName: t('pod'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'occurrence_time',
            headerName: t('occurrence_time'),
            width: 180,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'caused_by',
            headerName: t('caused_by'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
        },
        { field: 'caused_by', headerName: t('caused_by'), width: 175, valueGetter: (params) => getNameById(params, statusList.causedByList) },
        { field: 'result_type', headerName: t('result_type'), width: 225, valueGetter: (params) => getNameById(params, statusList.resultList) },
        { field: 'corrective_action', headerName: t('remedial_corrective_action'), width: 300, valueGetter: (params) => getNameById(params, statusList.correctiveActionList) },
        { field: 'review_type', headerName: t('review_type'), width: 250, valueGetter: (params) => getNameById(params, statusList.reviewTypeList) },
        { field: 'handler', headerName: t('handled_by'), width: 200, valueGetter: (params) => getUserById(params.value, userList)?.username || params.value },
        {
            field: 'close_time',
            headerName: t('close_time'),
            width: 180,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'key_account',
            headerName: t('key_account'),
            width: 180,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'compensated_date',
            headerName: t('compensated_date'),
            width: 180,
            headerAlign: 'center',
            align: 'center',
        }
    ];

    const handleExportToExcel = () => {
        const data = rows.map((item) => {
            const rowData = {};
            Column.forEach((col) => {
                if (col.field) {
                    if (col.valueGetter) {
                        rowData[col.field] = col.valueGetter({ value: item[col.field] });
                    } else {
                        rowData[col.field] = item[col.field] || '';
                    }
                }
            });
            return rowData;
        });
    
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    
        const fileName = "compensated_data.xlsx"; // Change the file name if needed
    
        XLSX.writeFile(wb, fileName);
    };    

    const rows = Array.isArray(props.data)
        ? props.data.map((item, index) => ({
            id: item.order_id,  // Use the array index as the unique ID for each row
            tracking_number: item.tno || '',
            shipping_staff_id: item.shipping_staff_id || '',
            warehouse: item.warehouse || '',
            driver_dispatches_record: item.scan_status || '',
            last_tracking_path: item.pathInfo || '',
            last_path_update: item.last_update_time || '',
            incident_id: item.id || '',
            incident_type: item.incident_type || '',
            status: item.status || '',
            notes: item.notes || '',
            driver_memo: item.driver_notes || '',
            pod: item.pod_verified || '',
            close_time: item.close_time || '',
            occurrence_time: item.occurrence_time || '',
            caused_by: item.caused_by || '',
            root_cause: item.root_cause || '',
            result_type: item.result_type || '',
            corrective_action: item.corrective_action || '',
            review_type: item.review_type || '',
            handler: item.handler || '',
            key_account: item.key_account || '',
            compensated_date: item.compensated_date || '',
        }))
        : [];
    const _handleEditOrderModal = (open, value) => {
        dispatch(handleEditOrderModal({
            open: open,
            orderIdentifier: value,
            type: 'tno'
        }));
    }

    const [selectedItemId, setSelectedItemId] = useState(null);

    return (
        <div style={{ width: 'flex', overflowY: 'auto' }}>
            <Box style={{ margin: 30, paddingRight: 40 }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '1rem' }}>
                    <Button
                        id="incidentmanagement_compensatedtable_downloadexcel_button"
                        variant="contained"
                        color="primary"
                        startIcon={<CloudDownloadIcon />}
                        className={classes.Button}
                        onClick={() => handleExportToExcel()}
                    >
                        {t('download')}
                    </Button>
                </div>
                <DataGrid
                    className={classes.root}
                    columns={Column}
                    rows={rows || []}
                    pagination
                    pageSize={PAGE_SIZE}
                    rowsPerPageOptions={[PAGE_SIZE]}
                    loading={props.isDataLoading}
                    rowCount={rows?.length || 0}
                    style={{ height: '75vh', Width: 'flex' }}
                />
            </Box>
            <EditOrderModal
                onClose={() => _handleEditOrderModal(false)}
                handleClose={() => _handleEditOrderModal(false)}
            />
        </div>

    );
}

export default CompensatedTable;